"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.registerOutlineItem = exports.PdfOutlineItem = void 0;
require("core-js/modules/es.number.constructor.js");
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));
var _get2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/get"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));
var _element = require("@onviobr/element");
var _pdfRenderer = require("@onviobr/pdf-renderer/pdf-renderer");
var _emitEvents = require("../../utils/emit-events");
var _bentoFonts = require("../../assets/bento-css/bento-fonts");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
(0, _pdfRenderer.registerPDFRenderer)();
var PdfOutlineItem = /*#__PURE__*/function (_BlueElement) {
  (0, _inherits2.default)(PdfOutlineItem, _BlueElement);
  var _super = (0, _createSuper2.default)(PdfOutlineItem);
  function PdfOutlineItem() {
    var _context, _context2;
    var _this;
    (0, _classCallCheck2.default)(this, PdfOutlineItem);
    _this = _super.call(this);
    _this.subItems = false;
    _this.layer = 0;
    _this.expanded = false;
    _this.text = undefined;
    _this.title = '';
    _this.handleExpandClick = (0, _bind.default)(_context = _this.handleExpandClick).call(_context, (0, _assertThisInitialized2.default)(_this));
    _this.navigate = (0, _bind.default)(_context2 = _this.navigate).call(_context2, (0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(PdfOutlineItem, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this$shadowRoot, _this$shadowRoot2;
      (0, _get2.default)((0, _getPrototypeOf2.default)(PdfOutlineItem.prototype), "connectedCallback", this).call(this);
      (this === null || this === void 0 ? void 0 : (_this$shadowRoot = this.shadowRoot) === null || _this$shadowRoot === void 0 ? void 0 : _this$shadowRoot.host).style.paddingLeft = "".concat(this.layer * 20 + 5, "px");
      this === null || this === void 0 ? void 0 : (_this$shadowRoot2 = this.shadowRoot) === null || _this$shadowRoot2 === void 0 ? void 0 : _this$shadowRoot2.host.addEventListener('click', this.navigate);
    }
  }, {
    key: "handleExpandClick",
    value: function handleExpandClick(e) {
      e.stopPropagation();
      if (this.subItems) {
        this.expanded = !this.expanded;
        (0, _emitEvents.emit)(this, 'toggle-expand', this.expanded);
      } else {
        this.navigate(e);
      }
    }
  }, {
    key: "navigate",
    value: function navigate(e) {
      e.stopPropagation();
      (0, _emitEvents.emit)(this, 'navigate');
    }
  }, {
    key: "renderClosedArrow",
    value: function renderClosedArrow() {
      return this.html(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["<span class=\"bento-icon-caret-right\"></span>"])));
    }
  }, {
    key: "renderOpenArrow",
    value: function renderOpenArrow() {
      return this.html(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["<span class=\"bento-icon-caret-down\"></span>"])));
    }
  }, {
    key: "renderDropDown",
    value: function renderDropDown() {
      return this.html(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["", ""])), this.expanded ? this.renderOpenArrow() : this.renderClosedArrow());
    }
  }, {
    key: "renderExpandButton",
    value: function renderExpandButton() {
      return this.html(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n      <button class=\"expand-button\" @click=\"", "\">\n        ", "\n      </button>"])), this.handleExpandClick, this.subItems ? this.renderDropDown() : null);
    }
  }, {
    key: "render",
    value: function render() {
      return this.html(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n      <style>\n        ", "\n        :host {\n          display: block;\n          margin-bottom: 3px;\n          margin-top: 3px;\n          padding: 5px;\n          cursor: pointer;\n          color: #212121;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n          line-height: 20px;\n        }\n        :host(:hover) {\n          background: rgba(33,33,33, .1)\n        }\n        .expand-button {\n          width: 20px;\n          min-width: 20px;\n          height: 100%;\n          padding: 0 4px 0 0;\n          border: none;\n          font-size: 16px;\n          outline: none;\n          cursor: pointer;\n          background: transparent;\n        }\n      </style>\n      ", "\n      ", ""])), _bentoFonts.bentoFonts, this.renderExpandButton(), this.text);
    }
  }], [{
    key: "is",
    get: function get() {
      return 'pdf-outline-item';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        text: {
          type: String,
          attribute: true,
          reflect: false
        },
        layer: {
          type: Number,
          attribute: true,
          reflect: false
        },
        subItems: {
          type: Boolean,
          attribute: true,
          reflect: false
        },
        expanded: {
          type: Boolean,
          attribute: true,
          reflect: false
        }
      };
    }
  }]);
  return PdfOutlineItem;
}(_element.BlueElement);
exports.PdfOutlineItem = PdfOutlineItem;
var registerOutlineItem = function registerOutlineItem() {
  return (0, _element.register)(PdfOutlineItem);
};
exports.registerOutlineItem = registerOutlineItem;
